var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEliminatePaperFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2688 5.20678L14.2786 4.64839C13.2183 4.61136 12.1868 4.99703 11.411 5.72054C10.6351 6.44404 10.1784 7.44613 10.1414 8.50635L9.02462 40.4869C8.9876 41.5471 9.37326 42.5786 10.0968 43.3545C10.8203 44.1303 11.8224 44.587 12.8826 44.624L36.868 45.4616C37.9282 45.4986 38.9597 45.113 39.7356 44.3895C40.5114 43.666 40.9681 42.6639 41.0051 41.6036L41.8427 17.6183L30.2688 5.20678Z",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2688 5.20679L29.85 17.1995L41.8427 17.6183",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4986 27.3328L17.5083 26.7744",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2195 35.3279L17.2292 34.7695",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7852 18.9189L19.7864 18.8491L17.7876 18.7793",
    stroke: "#3571D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminatePaperFile);
export default __webpack_public_path__ + "static/media/eliminate-paper-file.4525814fa263b9f1814befafa5622425.svg";
export { ForwardRef as ReactComponent };